export default {
  getReplenishmentAdvice: {
    url: '/inventory/getReplenishmentAdvice',
    method: 'post',
    desc: '获取补货建议列表'
  },
  getReplenishmentAdviceByASinExpand: {
    url: '/inventory/getReplenishmentAdviceByASinExpand',
    method: 'post',
    desc: '获取补货建议ASIN展开子列表'
  },
  getReplenishmentAdviceByMskuExpand: {
    url: '/inventory/getReplenishmentAdviceByMskuExpand',
    method: 'post',
    desc: '获取补货建议MSKU展开子列表'
  },
  getReplenishmentMskuAdvice: {
    url: '/replenishment/advices',
    method: 'post',
    desc: '获取补货建议MSKU列表'
  },
  getMskuAdvicesExpands: {
    url: '/replenishment/advices/expands',
    method: 'post',
    desc: '获取补货建议MSKU展开项-新'
  },
  onWayShipments: {
    url: '/replenishment/on_way_shipments',
    method: 'post',
    desc: '在途气泡',
  },
  updateOnWayShipment: {
    url: '/replenishment/update_on_way_shipment',
    method: 'post',
    desc: '更新在途',
  },
  setShipmentStatistics: {
    url: '/replenishment/set_shipment_statistics',
    method: 'get',
    desc: '是否取消在途信息统计',
  },
  allSalesForecastConfigItems: {
    url: '/replenishment/all_sales_forecast_config_items',
    method: 'get',
    desc: '获取日销配置列表'
  },
  bindSalesForecastConfig: {
    url: '/replenishment/bind_sales_forecast_config',
    method: 'post',
    desc: '绑定日销策略'
  },
  allPlatformStockUpConfigItems: {
    url: '/replenishment/all_platform_stock_up_config_items',
    method: 'get',
    desc: '获取备货配置列表'
  },
  bindPlatformStockUpConfig: {
    url: '/replenishment/bind_platform_stock_up_config',
    method: 'post',
    desc: '绑定备货策略'
  },
  businessTagItems: {
    url: '/business_tag_items',
    method: 'post',
    desc: '获取业务标签项'
  },
  saveBusinessTag: {
    url: '/save_business_tag',
    method: 'post',
    desc: '保存业务标签信息'
  },
  importBusinessTag: {
    url: '/import_business_tag',
    method: 'post',
    desc: '导入业务标签信息'
  },
  batchBindGoodsTag: {
    url: '/batch_bind_goods_tag',
    method: 'post',
    desc: '批量保存产品标签信息'
  },
  businessTagDetail: {
    url: '/business_tag_detail',
    method: 'get',
    desc: '获取业务标签详情'
  },
  deleteBusinessTag: {
    url: '/delete_business_tag',
    method: 'get',
    desc: '删除业务标签'
  },
  batchUnbindGoodsTag: {
    url: '/batch_unbind_goods_tag',
    method: 'post',
    desc: '批量解除产品和标签映射信息'
  },
  bindGoodsTag: {
    url: '/bind_goods_tag',
    method: 'post',
    desc: '保存产品和标签映射信息'
  },
}
